import React, {Component} from 'react';
import { navigateTo } from 'gatsby-link';
import Typist from 'react-typist';
import styles from './Welcome.module.scss';

export default class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typingDone: false,
      intervalId: null,
      counter: 0
    }

    this.onHeaderTyped = this.onHeaderTyped.bind(this);
    this.checkboxTimer = this.checkboxTimer.bind(this);
    this.tick          = this.tick.bind(this);
    this.changeLocation          = this.changeLocation.bind(this);
  }

  onHeaderTyped(){
    this.setState({typingDone:true});
    this.checkboxTimer();
  }

  checkboxTimer(){
    let timer = setInterval(this.tick, 1000);
    this.setState({intervalId:timer});

  }

  tick(){
    let num = this.state.counter + 1;
    this.setState({
      counter: num
    });
  }

  changeLocation(){
    clearInterval(this.state.intervalId)
    navigateTo('/about')
  }


  render() {
    return (
      <div className={styles.base}>
        <div className={styles.content}>

          {this.state.counter === 0 && (
              <Typist 
              onTypingDone={this.onHeaderTyped}
              avgTypingSpeed={80}>
                <span>Hi, I'm Casper </span>
              </Typist>
            )
          }

            {this.state.counter <= 1 && this.state.counter !== 0 && (
                <div className={styles.checkBoxes}>                  
                  <section className={styles.slider}>
                    <span className={styles.i}>
                      a&nbsp;
                    </span>
                    <span>
                      developer
                    </span>
                  </section>
                </div>
            )} 

            {this.state.counter <= 2  && this.state.counter > 1 && (
                <div className={styles.checkBoxes}>                  
                  <section className={styles.slider}>
                    <span className={styles.i}>
                      a&nbsp;
                    </span>
                    <span>
                      creator
                    </span>
                  </section>
                </div>
            )}   

            {this.state.counter <= 3 && this.state.counter > 2  && (
                <div className={styles.checkBoxes}>                  
                  <section className={styles.slider}>
                    <span className={styles.i}>
                      a&nbsp;
                    </span>
                    <span>
                      leader
                    </span>
                  </section>
                </div>
            )}   


            {this.state.counter >= 4  && (
              <div>
                {this.changeLocation()}
              </div>
            )}   
   
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.jsx